import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  backLink?: string;
}

export function PageHeader({ title, description, actions, backLink }: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="mb-8 space-y-4">
      {backLink && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(backLink)}
          className="gap-2 text-muted-foreground hover:text-foreground -ml-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Voltar
        </Button>
      )}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="animate-fade-in">
          <h1 className="text-2xl font-semibold tracking-tight text-foreground md:text-3xl">
            {title}
          </h1>
          {description && (
            <p className="mt-1 text-muted-foreground">{description}</p>
          )}
        </div>
        {actions && (
          <div className="flex items-center gap-3 animate-fade-in" style={{ animationDelay: '100ms' }}>
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
